import TopTicker from '@/pages/home/components/TopTicker';
import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import DownloadSection from '@/pages/home/components/DownloadSection';
import InstallSteps from '@/pages/home/components/InstallSteps';
import Features from '@/pages/home/components/Features';
import RankingSection from '@/pages/home/components/RankingSection';
import NewsSection from '@/pages/home/components/NewsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaBand from '@/pages/home/components/CtaBand';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopTicker />
      <Navbar />
      <main>
        <Hero />
        <DownloadSection />
        <InstallSteps />
        <Features />
        <RankingSection />
        <NewsSection />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}